import React, { useContext, useEffect, useState } from 'react';

import useLocalStorage from 'components/hooks/useLocalStorage';
import ObjectiveTreeView, { ObjectiveDisplayContext } from 'screens/home/tasksList/ObjectiveTreeView';
import styled from 'styled-components';

import { getTimePeriodIdString } from 'constants/helper';
import { DeliverableIcon } from 'constants/icons';
import { localStorageKeys } from 'constants/localStorageKeys';
import { sendAppliedFilterEvent } from 'constants/mixpanelHelper';

import FilterDisplay from './FilterDisplay';
import { getSelectedFiltersCountFromMap, getSelectedIdsFromSelectedMap } from './helper';

export const OBJECTIVE_FILTER_UPDATE = 'OBJECTIVE_FILTER_UPDATE';
const OBJECTIVE_FILTER_CLEAR = 'OBJECTIVE_FILTER_CLEAR';

export const initialObjectiveFilterState = {};

export const Wrapper = styled.div`
  opacity: ${({ disabled }) => (disabled ? '0.5' : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'inherit')};
  cursor: ${({ disabled }) => (disabled ? 'none' : 'pointer')};
  flex-basis: ${(props) => props.width || 'auto'};
`;
export function objectiveFilterReducer(state = initialObjectiveFilterState, action) {
  switch (action.type) {
    case OBJECTIVE_FILTER_UPDATE: {
      return { ...action.values };
    }
    case OBJECTIVE_FILTER_CLEAR: {
      return {};
    }
    default:
      return state;
  }
}

export function buildObjectiveFilters(selectedObjectives) {
  const ids = getSelectedIdsFromSelectedMap(selectedObjectives);
  return ids.map((id) => ({ type: 'TIMEBOUND_OBJECTIVE', value: id, operator: 'IN' }));
}

function ObjectiveDisplay({ selectedFilters, width = '15%', onClear, isDisabled = false }) {
  const { onClick, buttonRef } = useContext(ObjectiveDisplayContext);
  const selectedCount = isDisabled ? 0 : getSelectedFiltersCountFromMap(selectedFilters);

  return (
    <FilterDisplay
      width={width}
      ref={buttonRef}
      onClick={onClick}
      icon={<DeliverableIcon color="textSecondary" size="smallest" />}
      name="Objective"
      selectedCount={selectedCount}
      onClear={onClear}
    />
  );
}

export default function ObjectiveFilter({
  selectedFiltersDispatch,
  selectedFilters,
  width = '15%',
  isDisabled = false,
  selectedTimeBoundPeriod = null,
}) {
  const [selectedObjectiveLS, setSelectedObjectiveLS, removeItemObjectiveLS] = useLocalStorage(
    localStorageKeys.teamPageObjective,
    null
  );

  const [selectedObjective, setSelectedObjective] = useState(() => {
    if (!selectedObjectiveLS || !selectedTimeBoundPeriod) {
      return null;
    }
    if (
      getTimePeriodIdString(selectedObjectiveLS.timeBoundDetails) === getTimePeriodIdString(selectedTimeBoundPeriod)
    ) {
      selectedFiltersDispatch({
        type: OBJECTIVE_FILTER_UPDATE,
        values: { [selectedObjectiveLS.objectiveTimeBoundId]: true },
      });
      return selectedObjectiveLS;
    }

    // last timebound in which objective is saved and current selected timebound is not same, so discard LS stored objective filter
    removeItemObjectiveLS();
    return null;
  });

  function onObjectiveChange(tag) {
    selectedFiltersDispatch({
      type: OBJECTIVE_FILTER_UPDATE,
      values: { [tag.objectiveTimeBoundId]: true },
    });
    setSelectedObjective(tag);
    setSelectedObjectiveLS(tag);
    // setSelectedObjectiveLS(tag);
  }

  useEffect(() => {
    if (
      selectedObjectiveLS &&
      getTimePeriodIdString(selectedObjectiveLS.timeBoundDetails) !== getTimePeriodIdString(selectedTimeBoundPeriod)
    ) {
      selectedFiltersDispatch({ type: OBJECTIVE_FILTER_CLEAR });
      removeItemObjectiveLS();
      setSelectedObjective(null);
    }
  }, [selectedTimeBoundPeriod]);

  const onClear = (e) => {
    e.stopPropagation();
    selectedFiltersDispatch({ type: OBJECTIVE_FILTER_CLEAR });
    document.body.click();
    setSelectedObjective(null);
    removeItemObjectiveLS();
  };

  return (
    <Wrapper
      disabled={isDisabled}
      width={width}
      onClick={() =>
        sendAppliedFilterEvent({
          eventProperties: {
            filter: 'Objective',
            source: 'GOAL',
          },
        })
      }
    >
      <ObjectiveTreeView
        onObjectiveChange={onObjectiveChange}
        renderObjectiveDisplay={() => (
          <ObjectiveDisplay selectedFilters={selectedFilters} width={width} onClear={onClear} isDisabled={isDisabled} />
        )}
        menuType="tree_view_filter"
        onClear={onClear}
        allowTimePeriodChange={false}
        selectedTimeBoundPeriod={selectedTimeBoundPeriod}
        enableObjectiveCreation={false}
        selectedObjective={selectedObjective}
        timeboundIsDisabled
      />
    </Wrapper>
  );
}
